import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMe } from "@/features/auth/hooks";
import { useAuthStore } from "@/stores/auth.store";
import { OrganizationPolicyProvider } from "@/hooks/useOrganizationPolicy";

export function ProtectedLayout() {
  const location = useLocation();
  const initialized = useAuthStore((s) => s.initialized);
  const user = useAuthStore((s) => s.user);
  const query = useMe(!initialized);

  if (!initialized || query.isFetching) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Verificando sessão…</p>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // Spec 079 — a POLÍTICA DE JULGAMENTO da fábrica (limiares do OEE, faixas de aderência) fica
  // disponível para toda tela autenticada. Aqui, e não no `AppLayout`: a rota ambiente (TV com
  // sessão) fica fora do `AppLayout` e pinta os mesmos indicadores, e ela não pode ler a régua da
  // fábrica por uma cópia dos literais.
  //
  // Depois do gate de sessão de propósito: a leitura da organização exige token, e montar o
  // provider antes faria uma requisição 401 a cada carga da página de login.
  return (
    <OrganizationPolicyProvider>
      <Outlet />
    </OrganizationPolicyProvider>
  );
}
